import { Box, Tabs, Tab, Typography } from "@mui/material";
import { useNavigate, useLocation, To } from "react-router-dom";

import React from "react";
//import { Dashboard } from "./Dashboard";
import { Synthesize } from "./Synthesize";
import { Synchronize } from "./Synchronize";

export const Data = () => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = location.pathname;

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  const handleTabChange = (event: any, newValue: To) => {
    navigate(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box>
        <Typography variant="h4" sx={{ whiteSpace: "pre-line" }}>
          {`Currently Loaded Data`}
        </Typography>
        <Typography variant="body1" sx={{ whiteSpace: "pre-line", marginTop: "10px" }}>
          {`You can load data by synchronizing your existing data and/or synthesizing additional data to exercise various AI Strategies`}
        </Typography>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Synchronize" {...a11yProps(0)} />
          <Tab label="Synthesize" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        {<Synchronize />}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        {<Synthesize />}
      </CustomTabPanel>
    </Box>
  );

  /*
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Theme" {...a11yProps(0)} />
          <Tab label="Dashboard" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
      <Routes>
        <Route path="/" element={<ThemeList />} />
        <Route path="/theme/:id" element={<ThemeEdit />} />
      </Routes>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
    
      </CustomTabPanel>
    </Box>
  );
  */
};

export default Data;
